import { Breadcrumb } from "antd";
import { useContext, useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { useSession } from "../../api/Sessions";
import Loading from "../../components/Loading";
import SessionRow from "../../components/Session/SessionRow";
import { AuthContext } from "../../useAuth";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowLeft } from "@fortawesome/free-solid-svg-icons";
import { Link } from "react-router-dom";
import SessionCard from "../../components/Session/SessionCard";

const ViewSession = () => {
  return (
    <>
      <Breadcrumb>
        <Breadcrumb.Item>
          <Link to="/sessions">
            <FontAwesomeIcon icon={faArrowLeft} /> All Sessions
          </Link>
        </Breadcrumb.Item>
      </Breadcrumb>
      <Session />
    </>
  );
};

const Session = () => {
  const { user } = useContext(AuthContext);
  const [session, setSession] = useState();
  const [noSession, setNoSession] = useState();
  const { sessionId } = useParams();

  // Fetch session
  const { isLoading, data, isSuccess } = useSession(sessionId, user?.UserId);

  useEffect(() => {
    if (data) {
      if (validateSession(data)) setSession(data);
    }
    if (isSuccess && !data) setNoSession(true);
  }, [data, isSuccess]);

  // Validate user & time
  const validateSession = (session) => {
    const { attendees } = session;
    return attendees.some((a) => a.UserId === user?.UserId);
    // return attendees.where
  };

  return isLoading ? (
    <Loading message="Fetching session" />
  ) : noSession ? (
    <p>No session</p>
  ) : (
    <SessionCard sessionDetails={session} />
  );
};

export default ViewSession;
